module.exports = __webpack_public_path__ + "img/finance-stock-and-content.5208f68a.png";